import React from 'react';
import { UTLabel, UTCard, UTIconButton } from '@widergy/energy-ui';
import Delete from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import { string, number, func } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { actionCreators as userActions } from 'redux/user/actions';

import styles from './styles.module.scss';

const CardNextTurn = ({ id, procedureName, location, address, date, time, openCancelModal, dispatch }) => {
  const handleOpenCancelModal = () => openCancelModal(id);

  const handleEdit = () => {
    dispatch(userActions.setUpdateTurnData(id));
    dispatch(push(ROUTES.NEW_TURN));
  };

  return (
    <Grid item xs={12} md={6}>
      <UTCard flat className={styles.card}>
        <div className={styles.generalContainerLabels}>
          <div className={styles.containerLabels}>
            {procedureName && (
              <UTLabel darkGray bold className={styles.label}>
                {procedureName}
              </UTLabel>
            )}
            {location && (
              <UTLabel darkGray bold className={styles.label}>
                {`${message('Commons:office').toUpperCase()} ${location}`}
              </UTLabel>
            )}
            <UTLabel darkGray className={styles.label}>
              {address}
            </UTLabel>
          </div>
          <div className={styles.containerLabels}>
            <UTLabel darkGray className={styles.label}>
              {date}
            </UTLabel>
            <UTLabel darkGray className={styles.label}>
              {time}
            </UTLabel>
          </div>
        </div>
        <div className={styles.containerButtons}>
          <UTIconButton onClick={handleEdit} className={styles.iconButton}>
            <Edit />
          </UTIconButton>
          <hr className={styles.divider} />
          <UTIconButton onClick={handleOpenCancelModal} className={styles.iconButton}>
            <Delete />
          </UTIconButton>
        </div>
      </UTCard>
    </Grid>
  );
};

CardNextTurn.propTypes = {
  procedureName: string,
  address: string,
  date: string,
  location: string,
  time: string,
  id: number,
  openCancelModal: func
};

export default connect()(CardNextTurn);
